<ng-container *ngIf="!!get">
    <ng-container *ngIf="!(['mobile', 'tablet'] | mediaQuery)">
        <tt-card class="col-xs-12 col-md-4 p-5" ttHeading="bg_personinfo_person">
            <ng-container [ngTemplateOutlet]="personForm"></ng-container>
        </tt-card>

        <tt-card *ngIf="facts.length > 0" class="col-xs-12 col-md-4 p-5" ttHeading="bg_personinfo_persfacts">
            <ng-container [ngTemplateOutlet]="factsForm"></ng-container>
        </tt-card>

        <tt-card class="col-xs-12 col-md-4 p-5" ttHeading="bg_personinfo_email">
            <ng-container [ngTemplateOutlet]="emailForm"></ng-container>
        </tt-card>

        <tt-card class="col-xs-12 col-md-4 p-5">
            <ng-container [ngTemplateOutlet]="functions"></ng-container>
        </tt-card>
    </ng-container>
    <ng-container *ngIf="['mobile', 'tablet'] | mediaQuery">
        <tt-tabs #tabs>
            <tt-tab ttId="BASIC" ttLabel="bg_personinfo_person"></tt-tab>
            <tt-tab ttId="PERSFACTS" ttLabel="bg_personinfo_persfacts"></tt-tab>
            <tt-tab ttId="EMAIL" ttLabel="bg_personinfo_email"></tt-tab>
        </tt-tabs>
        <tt-card [hidden]="tabs.ttSelectedId !== 'BASIC'">
            <ng-container [ngTemplateOutlet]="personForm"></ng-container>
        </tt-card>
        <tt-card [hidden]="tabs.ttSelectedId !== 'PERSFACTS'">
            <ng-container [ngTemplateOutlet]="factsForm"></ng-container>
        </tt-card>
        <tt-card [hidden]="tabs.ttSelectedId !== 'EMAIL'">
            <ng-container [ngTemplateOutlet]="emailForm"></ng-container>
        </tt-card>
        <tt-card>
            <ng-container [ngTemplateOutlet]="functions"></ng-container>
        </tt-card>
    </ng-container>
</ng-container>

<ng-template #personForm>
    <ng-container *ngIf="!!get">
        <tt-input ttLabel="cust_name" [(ttModel)]="get.cust_name" ttReadonly>
            <tt-form-field-button buttons ttIcon="fas fa-chevron-right" ttGoto="customersmenu" [ttGotoParms]="{ cust_no: get.cust_no }"></tt-form-field-button>
        </tt-input>
        <tt-input ttLabel="pers_name" [(ttModel)]="get.pers_name"></tt-input>
        <tt-input ttLabel="pers_jobtitle" [(ttModel)]="get.pers_jobtitle"></tt-input>
        <tt-checkbox ttLabel="pers_importance" [(ttModel)]="get.pers_importance"></tt-checkbox>
        <tt-textarea ttLabel="note" [(ttModel)]="get.pers_note"></tt-textarea>
        <tt-input-email ttLabel="email" [(ttModel)]="get.pers_email"></tt-input-email>
        <tt-input-phone *ngFor="let phone of phoneNumbers" [ttLabel]="phone.phonetype_name" ttTranslateLabel="false" [(ttModel)]="phone.phone_number"></tt-input-phone>
    </ng-container>
</ng-template>

<ng-template #factsForm>
    <ng-container *ngIf="!!get">
        <ng-container *ngFor="let fact of facts">
            <tt-textarea *ngIf="fact.elementtype === 'T'" [ttLabel]="fact.pers_facts_name" ttTranslateLabel="false" [(ttModel)]="fact.note"></tt-textarea>
            <tt-input-number *ngIf="fact.elementtype === 'N2'" [ttLabel]="fact.pers_facts_name" ttTranslateLabel="false" [(ttModel)]="fact.number" ttTextAlign="right" ttDecimals="2"></tt-input-number>
            <tt-checkbox *ngIf="fact.elementtype === 'CB'" [ttLabel]="fact.pers_facts_name" ttTranslateLabel="false" [(ttModel)]="fact.checkbox"></tt-checkbox>
        </ng-container>
    </ng-container>
</ng-template>

<ng-template #emailForm>
    <ng-container *ngIf="!!get">
        <tt-input-email ttLabel="email" [(ttModel)]="get.pers_email"></tt-input-email>
        <tt-checkbox ttLabel="invoice_email" [(ttModel)]="get.invoice_email"></tt-checkbox>
        <tt-checkbox ttLabel="purchorder_email" [(ttModel)]="get.purchorder_email"></tt-checkbox>
        <tt-checkbox ttLabel="caselabel_purchase" [(ttModel)]="get.caselabel_purchase"></tt-checkbox>
        <tt-checkbox ttLabel="crm_mail" [(ttModel)]="get.crm_mail"></tt-checkbox>
        <tt-checkbox ttLabel="orderconfirm_email" [(ttModel)]="get.orderconfirm_email"></tt-checkbox>
        <tt-checkbox ttLabel="delivery_email" [(ttModel)]="get.delivery_email"></tt-checkbox>
    </ng-container>
</ng-template>

<ng-template #functions>
    <ng-container *ngIf="!!get">
        <tt-button-save (ttClick)="save()" [ttLoading]="saving"></tt-button-save>
        <tt-button *ngIf="+get.pers_no > 0" ttText="delete" ttIcon="fad fa-trash" ttType="danger" (ttClick)="deletePerson()" [ttLoading]="deleting"></tt-button>
        <tt-button-settings ttWebpageName="person"></tt-button-settings>
    </ng-container>
</ng-template>
